import type { PaymentLimitsTranslations } from "../interfaces/paymentLimits";

export const paymentLimitsTranslations: PaymentLimitsTranslations = {
  // Page
  page_title: "Límites de monto",
  page_subtitle:
    "Mínimo y máximo por operación, por riel y tipo de pagador, global o por organización, sin despliegues",
  refresh_button: "Actualizar",
  refresh_aria: "Actualizar los límites",
  why_banner:
    "Un monto fuera de rango se rechaza al previsualizar y al crear la operación. Lo que ya está en vuelo no se toca: se liquida con normalidad.",

  // Scope selector
  scope_label: "Alcance",
  scope_placeholder: "Buscar por nombre, correo o ID…",
  scope_loading: "Cargando organizaciones…",
  scope_empty: "No se encontraron organizaciones.",
  scope_searching: "Buscando organizaciones…",
  scope_search_error: "No pudimos completar la búsqueda; se muestran las organizaciones ya cargadas.",
  scope_global_option: "Global (todas las organizaciones)",
  scope_global_label: "Global",
  scope_global_hint: "Alcance global: los límites que hereda cualquier organización sin override propio.",
  scope_org_hint:
    "Los cambios aquí crean un override para esta organización, que gana sobre los límites globales.",
  scope_catalog_error:
    "No pudimos cargar el catálogo de organizaciones; los overrides pueden mostrar IDs en lugar de nombres.",
  scope_catalog_truncated:
    "Hay más organizaciones de las listadas; escribe para buscarlas todas. Algunos overrides pueden mostrar el ID.",

  // KPI strip
  kpi_all: "Corredores",
  kpi_limited: "Con límite",
  kpi_overrides: "Con overrides",
  kpi_own_overrides: "Con override propio",

  // Table / cards
  section_payins: "Cobros (payins)",
  section_payouts: "Pagos (payouts)",
  th_rail: "Riel",
  th_country: "País",
  th_currency: "Moneda",
  th_person: "Persona natural",
  th_company: "Empresa",
  th_source: "Origen",
  th_overrides: "Overrides",
  direction_payin: "Cobros",
  direction_payout: "Pagos",
  country_ar: "Argentina",
  country_br: "Brasil",
  country_co: "Colombia",
  country_mx: "México",
  bound_min: "Mín.",
  bound_max: "Máx.",
  bound_none: "Sin límite",
  payer_both: "Ambos",
  payer_person: "Persona natural",
  payer_company: "Empresa",
  source_default: "Sin límite configurado",
  source_global_setting: "Límite global",
  source_global: "Hereda del global",
  source_org_override: "Override de la organización",
  overrides_count: "{{count}} overrides",
  overrides_count_one: "1 override",
  overrides_count_other: "{{count}} overrides",
  overrides_popover_hint: "Toca una organización para abrir su vista y gestionar su override.",
  action_edit: "Editar",
  action_remove: "Quitar límite",
  action_clear_override: "Quitar override",
  empty_title: "Sin corredores que mostrar",
  empty_description: "Ningún corredor coincide con el filtro seleccionado.",

  // Edit dialog
  dialog_title: "Límites de {{rail}}",
  dialog_scope_global: "Aplica a todas las organizaciones sin override propio.",
  dialog_scope_org: "Crea un override solo para la organización seleccionada.",
  dialog_consequence:
    "Desde que guardes, un monto fuera de este rango se rechaza al previsualizar y al crear. Lo que ya está en vuelo no se toca.",
  payer_type_label: "Aplica a",
  payer_type_hint:
    "Una fila por tipo de pagador gana sobre la fila de «Ambos». En PSE el pagador declara si es natural o jurídico; en los demás rieles se infiere del documento.",
  min_label: "Mínimo por operación",
  max_label: "Máximo por operación",
  unbounded_placeholder: "Sin límite",
  reason_label: "Motivo (opcional)",
  reason_placeholder: "Ej.: tope de la red para persona natural",
  reason_internal_hint:
    "El motivo es de uso interno: solo lo ve el equipo de Coloca. El cliente ve el mensaje genérico con el límite.",
  validation_money: "Escribe un monto válido.",
  validation_at_least_one: "Indica al menos un mínimo o un máximo.",
  validation_min_below_max: "El mínimo debe ser menor que el máximo.",
  validation_fraction_digits: "{{currency}} admite hasta {{digits}} decimales.",
  dialog_cancel: "Cancelar",
  dialog_submit: "Guardar límite",

  // Remove dialog
  clear_title: "Quitar el límite",
  clear_description: "El corredor quedará sin límite configurado en el alcance global.",
  clear_override_description:
    "La organización volverá a heredar los límites globales de este corredor (o a no tener límite).",
  clear_rows_intro: "Se eliminarán estas filas:",
  clear_confirm: "Quitar",
  clear_cancel: "Cancelar",

  // Toasts / errors
  toast_saved: "Límite de {{rail}} guardado.",
  toast_cleared: "Límite de {{rail}} eliminado.",
  error_load: "No pudimos cargar los límites.",
  error_load_detail: "Revisa tu conexión e inténtalo de nuevo.",
  error_retry: "Reintentar",
  error_save: "No pudimos guardar el cambio.",
  error_no_write_permission: "Tu usuario no tiene permiso de escritura sobre pagos.",
};
